import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'competitors-table',
  templateUrl: './competitors-table.component.html',
  styleUrls: ['./competitors-table.component.scss'],
})
export class CompetitorsTableComponent implements OnInit {
  // list of models object for select dropdown
  dropDownList: { [key: string]: Array<any> } = {};
  // id field to edit, first in line in columnData
  idFieldName: string;
  compShops: Array<any>;

  @Input() dataService: any;
  @Input() compStores: any;
  @Input() columnsData: Array<any>;
  @Input() competitorsIDs: Array<number>;

  @Output()
  compDescription: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  displayedColumns = [];

  constructor(
  ) {
  }


  ngOnInit(): void {
    // create orderby;
    // this field is created in order as an ID
    // create @input if want to specify for every table
    this.idFieldName = this.columnsData.shift().columnDef;
    // get column name from models
    this.displayedColumns = this.columnsData.map(c => c.columnDef);
  }

  public navigateToPage(id: number) {
    //   this.router.navigate(['metadata/articles/add', id]);
  }

}
